export const getLayerStrokeDashes = (layer: any) => {
  if (!layer.strokeDashes) {
    return [];
  }

  return layer.strokeDashes;
};
